import styled from 'styled-components';

export const HiddenH1 = styled.h1`
  && {
    visibility: hidden;
    height: 0;
    margin: 0;
  }
`;
